/**
 * @description 理賠服務-車主身份別
 */
export enum ClaimCarOwnerType {
    /** 車主本人 */
    Self = '1',
    /** 非車主本人 */
    Other = '0'
}
